import { render, staticRenderFns } from "./ModalProcessorDetails.vue?vue&type=template&id=8c4c1c98"
import script from "./ModalProcessorDetails.vue?vue&type=script&lang=js"
export * from "./ModalProcessorDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessorDetails.vue?vue&type=style&index=0&id=8c4c1c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports